import React, { CSSProperties, useEffect } from 'react';
import { styled, Theme, Typography, Link } from '@material-ui/core';
import { useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import { useDispatch } from 'react-redux';
import { Banner, resetBanner } from 'src/modules/shared/slices/banner/entity/bannerSlice';
import theme from 'src/config/theme';

const getBackgroundColor = (type: Banner['type']): string => {
  let color = theme.palette.primary.main;
  if (!type) return color;
  switch (type) {
    case 'demo':
      color = theme.palette.primary.main;
      break;

    default:
      break;
  }
  return color;
};

const BannerWrapper = styled('div')<
  Theme,
  { justifyContent: CSSProperties['justifyContent']; type: Banner['type'] }
>(({ theme, justifyContent, type }) => ({
  backgroundColor: getBackgroundColor(type),
  height: theme.config.messageBarHeightPx,
  color: theme.palette.common.white,
  display: 'flex',
  justifyContent,
  alignItems: 'center',
  padding: '0 16px',
  width: '100%',
  [theme.breakpoints.down('xs')]: {
    padding: '10px 16px',
    height: `${theme.config.mobileMessageBarHeight}px`,
  },
}));
/* 
const topBarBanners = [
  {
    showBanner: true,
    targetRoles: [UserRoles.TEACHER, UserRoles.AUTHOR],
    justifyContent: 'flex-start',
    type: 'demo' as BannerTypes,
    messageStart:
      'Je bent op het demoplatform. Vanaf midden juli wordt je overgeschakeld naar app. ',
    url: 'https://www.lernova.be/vlotvanstart#tijdslijn',
    urlDescription: 'Meer info.',
  },
  {
    showBanner: true,
    targetRoles: [UserRoles.TEACHER, UserRoles.AUTHOR],
    justifyContent: 'flex-start',
    type: 'production' as BannerTypes,
    url: 'https://www.lernova.be/vlotvanstart#tijdslijn',
    urlDescription: ' Wat gebeurt er met je Lernova lesmethode ',
    messageEnd: ' tijdens de zomervakantie?',
  },
  {
    showBanner: true,
    targetRoles: [UserRoles.TEACHER, UserRoles.AUTHOR],
    justifyContent: 'flex-start',
    type: 'staging' as BannerTypes,
    url: 'https://www.lernova.be/vlotvanstart#tijdslijn',
    urlDescription: ' Wat gebeurt er met je Lernova lesmethode ',
    messageEnd: ' tijdens de zomervakantie?',
  },
];
 */
const AppBanner = () => {
  const dispatch = useDispatch();
  const showBanner = useAppSelector((state) => state.banner.showBanner);
  const messageStart = useAppSelector((state) => state.banner.messageStart);
  const messageEnd = useAppSelector((state) => state.banner.messageEnd);
  const url = useAppSelector((state) => state.banner.url);
  const urlDescription = useAppSelector((state) => state.banner.urlDescription);
  const justifyContent = useAppSelector((state) => state.banner.justifyContent);
  const type = useAppSelector((state) => state.banner.type);
  const bannerContent = useAppSelector((state) => state.banner.bannerContent);

  useEffect(() => {
    return () => {
      dispatch(resetBanner());
    };
  }, [dispatch]);

  if (!showBanner) return null;

  return (
    <BannerWrapper id="banner" justifyContent={justifyContent} type={type}>
      <Typography>
        {messageStart}
        {url && (
          <Link href={url} underline="always" style={{ color: 'white' }} rel="noopener noreferrer">
            {urlDescription ?? url}
          </Link>
        )}
        {messageEnd}
        {bannerContent && bannerContent}
      </Typography>
    </BannerWrapper>
  );
};

export default AppBanner;
